import { render } from "./CourseForm.vue?vue&type=template&id=59ab67d5"
import script from "./CourseForm.vue?vue&type=script&lang=js"
export * from "./CourseForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__